import { render } from "./DonneePerso.vue?vue&type=template&id=71d1daf2&scoped=true"
import script from "./DonneePerso.vue?vue&type=script&lang=js"
export * from "./DonneePerso.vue?vue&type=script&lang=js"

import "./DonneePerso.vue?vue&type=style&index=0&id=71d1daf2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d1daf2"]])

export default __exports__